document.addEventListener("DOMContentLoaded", () => {
    // Run once now
    addDomain();

    // Run again whenever new nodes are injected by lazy-load
    const observer = new MutationObserver(addDomain);
    observer.observe(document.body, { childList: true, subtree: true });
});

function addDomain() {
    document.querySelectorAll('input[data-domain]').forEach((input) => {
        if (!input.value) {
            input.value = window.location.href;
        }
    });
}